<template>
  <div class="row">
    <div
      class="
        col-md-12
        justify-content-end
        float-right
        modal-header
        px-5
        align-items-center
      "
    >
      <div class="header-container row justify-content-between">

        <div class="modal-title-container">
          <h3 v-if="title" class="text-left">{{ title }}</h3>
        </div>
        <button class="close close-btn" @click="close">
          <font-awesome-icon icon="times" />
        </button>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "modal-header",
  props: ["title", "close"],
};
</script>

<style scoped>
.header-container {
  width: 100%;
}

.empty-space {
  width: 8%;
}

.modal-header {
  background: #000000;
  border: none;
  height: 85px;
}

.modal-header h3 {
  color: #fff !important;
  margin: 0;
  font-family: artifaktElementBold !important
}

.modal-title-container {
  width: 80%;
}

.close-btn {
  outline: none;
  cursor: pointer;
  width: 10%;
}

.close-btn svg {
  color: #fff;
}
</style>